import React from 'react';
import { connect } from 'react-redux';
import { Loader, Message } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { firstError, firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import RequestSourceHeader from '../components/RequestSourceHeader';
import RequestAttachmentsCards from '../attachments/components/RequestAttachmentsCards';
import RequestAttachmentsTable from '../attachments/components/RequestAttachmentsTable';
import { requestSources } from '../constants';
import { newRequest, resolveRequestWorkflow } from '../state/state';

const SelectRequestAttachments = ({
  category,
  code,
  compact,
  name,
  readErrors,
  readStatus,
  sourceCode,
  sourceType,
}) => {
  const intl = useIntl();
  const AttachmentsComponent = compact ? RequestAttachmentsCards : RequestAttachmentsTable;

  return (
    <div className="aridhia-select-request-attachments aridhia-wizard-content">
      {name && (<RequestSourceHeader category={sourceType} code={sourceCode} name={name} />)}
      {firstError(readErrors) && (
        <Message
          className="modal-message"
          error
          size="small"
          icon="warning circle"
          key="errors"
          header={intl.formatMessage({ id: 'access.request.close.error' })}
          content={firstErrorMessage(readErrors)}
        />
      )}
      {readStatus === states.PENDING && (<Loader active inline="centered" />)}
      <AttachmentsComponent code={code} category={category} />
    </div>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request, source } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const safeSource = source || { code: null };
  const { attachments } = request.steps;

  return (
    {
      name: request.request_source === requestSources.COHORT ? safeSource.name : safeSource.catalogue?.title,
      readErrors: attachments.readErrors,
      readStatus: attachments.readStatus,
      sourceCode: safeSource.code,
      sourceType: request.request_source,
    }
  );
};

export default connect(mapStateToProps)(SelectRequestAttachments);
